module.exports = __webpack_public_path__ + "img/3-4.159d1574.jpg";